export const downloadFileFromBase64 = (fileName: string, base64Contend: string, applicationType: string) => {
  downloadFileFromBytes(fileName, base64ToArrayBuffer(base64Contend), applicationType);
};

export const openFileInNewTab = (title: string, base64Contend: string, applicationType: string) => {
  openFileInNewTabFromBytes(title, base64ToArrayBuffer(base64Contend), applicationType);
};

export const downloadFile = (fileName: string, base64Contend: string, applicationType: string) => {
  downloadFileFromBytes(fileName, base64ToArrayBuffer(base64Contend), applicationType);
};

export const openFileInNewTabFromBytes = (title: string, bytes: any, applicationType: string) => {
  const blob = new Blob([bytes], { type: applicationType });
  const blobUrl = window.URL.createObjectURL(blob);

  const html = `
    <!DOCTYPE html>
    <html lang="hr">
      <head>
        <meta charset="UTF-8">
        <title>${title || ''}</title>
        <style>
          html, body { margin: 0; height: 100%; }
          iframe { width: 100%; height: 100%; border: none; }
        </style>
      </head>
      <body>
        <iframe src="${blobUrl}" />
      </body>
    </html>
  `;

  const blobPage = new Blob([html], { type: 'text/html' });
  const pageUrl = window.URL.createObjectURL(blobPage);
  window.open(pageUrl, '_blank');
};

export const downloadFileFromBytes = (fileName: string, bytes: any, applicationType: string) => {
  const blob = new Blob([bytes], { type: applicationType });
  const link = document.createElement('a');
  link.href = window.URL.createObjectURL(blob);
  link.download = fileName;
  link.click();
};
export const fileToBase64 = (file: File) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(('' + reader.result).split(',')[1]);
    reader.onerror = error => reject(error);
  });
};

function base64ToArrayBuffer(base64) {
  const binaryString = window.atob(decodeURI(base64));
  const binaryLen = binaryString.length;
  const bytes = new Uint8Array(binaryLen);
  for (let i = 0; i < binaryLen; i++) {
    bytes[i] = binaryString.charCodeAt(i);
  }
  return bytes;
}
